import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { UnAuthCustomerAddressesActions, UnAuthCustomerAddressesState } from "./types";
import { activeModule } from "../active-module";

const initialState: UnAuthCustomerAddressesState = {
  unAuthedCustomerAddresses: [],
  currentShippingAddressId: "",
};

export const useCustomerAddressesStorageState = create<UnAuthCustomerAddressesState & UnAuthCustomerAddressesActions>()(
  persist<UnAuthCustomerAddressesState & UnAuthCustomerAddressesActions>(
    (set, get) => {
      return {
        ...initialState,

        resetAuthedCustomerAddresses: () => {
          set(initialState);
        },

        resetUnAuthedCustomerAddresses: () => {
          set((state) => {
            return {
              ...state,
              unAuthedCustomerAddresses: [],
            };
          });
        },

        clearStorage: () => {
          console.log("clearStorage");
          useCustomerAddressesStorageState.persist.clearStorage();
        },

        addAddress: (addr) => {
          set((state) => {
            return {
              ...state,
              unAuthedCustomerAddresses: [...state.unAuthedCustomerAddresses, addr],
            };
          });
        },

        removeAddress: (id) => {
          set((state) => {
            return {
              ...state,
              unAuthedCustomerAddresses: state.unAuthedCustomerAddresses.filter((addr) => addr.id !== id),
            };
          });
        },

        editAddress: (id, updatedAddress) => {
          set((state) => {
            return {
              ...state,
              unAuthedCustomerAddresses: state.unAuthedCustomerAddresses.map((addr) =>
                addr.id === id ? { ...addr, ...updatedAddress } : addr
              ),
            };
          });
        },

        setCurrentShippingAddressId: (id, source) => {
          console.log({ id, source });

          set((state) => {
            return {
              ...state,
              currentShippingAddressId: id,
            };
          });
        },
      };
    },
    {
      name: `${activeModule}-un-auth-customer-addresses-data`,
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export const useCustomerAddressesStorageData = () => {
  return useCustomerAddressesStorageState((state) => ({
    ...state,
  }));
};
